import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/views/layout/index.vue'
import HomeView from '../views/HomeView.vue'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/home',
		component: layout,
		children: [
			{
				path: '/home',
				name: 'home',
				component: HomeView
			},
			{
				path: '/product',
				name: 'product',
				component: () => import('@/views/productCenter.vue')
			},
			{
				path: '/support',
				name: 'support',
				component: () => import('@/views/support.vue')
				
			},
			{
				path: '/distribute',
				name: 'distribute',
				component: () => import('@/views/distribute.vue')
			},
			{
				path: '/blueframe',
				name: 'blueframe',
				component: () => import('@/views/blueframe.vue')
			},
			{
				path: '/aboutus',
				name: 'aboutus',
				component: () => import('@/views/aboutus.vue')
			}
		]
	},
	{
		path: '/agreement',
		name: 'agreement',
		component: () => import('@/views/agreement.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
